|
<span class="pds-text"> PDS </span>
<span
  #tooltip
  class="custom-tooltip"
  [class.top]="top"
  [class.top1]="top && !cpi"
>
  <ul>
    <li *ngIf="cpi">Supplier CPI = {{ cpi }}</li>
    <li>PDS Fee = {{ fee }}</li>
  </ul>
</span>
